import React from "react";
import { useState } from "react";

const WineCard = ({ wine, handlePreview, setCurrentProduct }) => {
  const [isWineModalOpen, setIsWineModalOpen] = useState(false);

  const handleModal = () => {
    console.log("clicked");
    setIsWineModalOpen(!isWineModalOpen);
  };

  const handleAddToCart = () => {
    handlePreview();
    setCurrentProduct(wine.id);
  }
  return (
    <div className="wine-card">
      <div className="wine-information">
        <h5 className="wine-card-title">{wine.name}</h5>
        <span>
          {/* {wine.id} */}
          {wine.short}
          <br/>          
        ${wine.price}
        </span>
        <div className="wine-buttons">
          <div onClick={handleModal}>more info</div>
          <button className="add-to-cart-btn"
            onClick={handleAddToCart}
            >
            Add to Cart
          </button>
        </div>
      </div>

      <img className="product-img" src={wine.image} />

      <div className={`modal ${isWineModalOpen ? "is-active" : ""}`}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <h1 className="modal-card-title">{wine.name}</h1>
            <button className="delete" aria-label="close" onClick={handleModal}></button>
          </header>
          <section className="modal-card-body">
            <img className="product-img" src={wine.image} />
            <div>
              <p>
                {wine.description}
              </p>
              <p>
                ${wine.price}
              </p>
            </div>
          </section>
          <footer className="modal-card-foot">
            <button className="modal-btn" onClick={handleAddToCart}>Add to Cart</button>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default WineCard;
